import { TFunction } from "@impero-com/common/utils/i18n";
import { assertNever } from "@impero-com/common/utils/obj";
import { Tag } from "@impero-com/ui";

import { EventSource } from "api/generated/model";

import * as theme from "./eventSourceTag.css";

/**
 * The label shown for sources that are called out to the user. Web is the
 * default channel and System has no user behind it, so neither gets a label.
 */
export function eventSourceLabel(
    t: TFunction,
    source: EventSource | null | undefined
): string | null {
    switch (source) {
        case "Agent":
            return t("EventSourceTag_Agent");
        case "PublicApi":
            return t("EventSourceTag_Api");
        case "Web":
        case "System":
        case null:
        case undefined:
            return null;
        default:
            return assertNever(source);
    }
}

export function eventSourceTag(
    t: TFunction,
    source: EventSource | null | undefined
) {
    const label = eventSourceLabel(t, source);
    return label === null ? null : (
        <Tag variant="applied" className={theme.tag}>
            {label}
        </Tag>
    );
}
